module.exports = __webpack_public_path__ + "site_static/img/data_bg_img.d521222.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneimg/data_bg_img.jpg
// module id = jUya
// module chunks = 0